import React from "react";
import { TRUSTED_BY } from "../mock";

/**
 * Animated marquee strip showing client/brand names.
 * Uses CSS keyframes for infinite horizontal scroll.
 */
const TrustedMarquee = () => {
  const items = [...TRUSTED_BY, ...TRUSTED_BY];
  return (
    <section className="relative py-14 border-y border-white/5 bg-white/[0.015]">
      <div className="cga-container px-6">
        <p className="text-center text-xs uppercase tracking-[0.25em] text-white/45 mb-7">
          Trusted by growth-driven businesses
        </p>
      </div>
      <div className="relative overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 w-32 z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(90deg, #000, transparent)",
          }}
        />
        <div
          className="absolute inset-y-0 right-0 w-32 z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(-90deg, #000, transparent)",
          }}
        />
        <div className="cga-marquee-track flex gap-14 whitespace-nowrap">
          {items.map((name, i) => (
            <div
              key={i}
              className="text-white/55 font-semibold tracking-tight text-xl flex items-center gap-3"
            >
              <span
                className="w-2 h-2 rounded-full bg-[#5eead4]/70"
                aria-hidden
              />
              {name}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes cga-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .cga-marquee-track {
          animation: cga-marquee 35s linear infinite;
          width: max-content;
        }
      `}</style>
    </section>
  );
};

export default TrustedMarquee;
